<template>
    <div class="h-100 bg-light" style="overflow-x:hidden;overflow-y: auto">
        <van-form @submit="onSubmit" :show-error-message="false" ref="MeetingForm">
            <van-cell-group :title="$route.meta && $route.meta.nickname || $route.name">
                <van-field
                    v-model="single.topic"
                    name="topic"
                    label="主题"
                    placeholder="请输入主题"
                    :rules="[{ required: true}]"
                    clearable
                />
                <van-field
                    readonly
                    clickable
                    name="room_group"
                    :value="findLabel(single.group_id,allRoomGroups,'id')"
                    label="会议组"
                    placeholder="选择会议组"
                    @click="show_picker.group_id = true"
                />
                <van-popup v-model="show_picker.group_id" position="bottom">
                    <van-picker
                        show-toolbar
                        value-key="name"
                        :columns="allRoomGroups"
                        @confirm="(v1) => onPickConfirm('group_id',v1)"
                        @cancel="show_picker.group_id = false"
                    />
                </van-popup>
            </van-cell-group>

            <van-cell-group title="时间">
                <van-field
                    readonly
                    clickable
                    name="calendar"
                    :value="single.meeting_date"
                    label="会议日期"
                    placeholder="点击选择日期"
                    :disabled="!canAdd"
                    @click="showCalendar = true"
                />
                <van-calendar v-model="showCalendar" @confirm="onConfirmDate" :show-confirm="false"/>
                <van-field
                    readonly
                    clickable
                    name="datetimePicker"
                    :value="single.meeting_time"
                    label="会议时间"
                    placeholder="点击选择时间"
                    @click="showDateTimePicker = true"
                    :disabled="!canAdd"
                />
                <van-popup v-model="showDateTimePicker" position="bottom">
                    <van-datetime-picker
                        type="time"
                        v-model="single.meeting_time"
                        :default-date="$dateParse(single.meeting_date)"
                        :filter="timeFilter"
                        @confirm="onConfirmTime"
                        @cancel="showDateTimePicker = false"
                    />
                </van-popup>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="findLabel(single.duration,duration_options)"
                    label="选择时长"
                    placeholder="点击选择时长"
                    @click="showDurationPicker = true"
                />
                <van-popup v-model="showDurationPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        value-key="label"
                        :columns="duration_options"
                        @confirm="onDurationConfirm"
                        @cancel="showDurationPicker = false"
                    />
                </van-popup>
                <van-cell class="px-1">
                    <meeting-freebusy ref="meeting_busy"
                                      :jump="canAdd"
                                      @change='handleFreeChange'
                                      :date="single.meeting_date"
                                      :id="single.id"
                                      :group="single.group_id"
                                      :duration="single.duration"
                                      :time="single.meeting_time">
                    </meeting-freebusy>
                </van-cell>
            </van-cell-group>

            <van-cell-group title="其他">
                <van-field name="waiting_room" label="等候室">
                    <template #input>
                        <van-switch v-model="single.waiting_room" size="20" active-value="1" inactive-value="0" @change="changeCheck(0)"/>
                    </template>
                </van-field>
                <van-field name="option_jbh" label="提前参会">
                    <template #input>
                        <van-switch v-model="single.option_jbh" size="20" active-value="1" inactive-value="0" @change="changeCheck(1)"/>
                    </template>
                </van-field>
                <van-field name="option_mute" label="静音入会">
                    <template #input>
                        <van-switch v-model="single.option_mute" size="20" active-value="1" inactive-value="0"/>
                    </template>
                </van-field>
                <van-field name="option_interpreter" label="开启同传">
                    <template #input>
                        <van-switch v-model="single.option_interpreter" :disabled="single && single.id && isTencentMeeting"
                                    size="20" active-value="1" inactive-value="0"/>
                    </template>
                </van-field>
                <van-field name="option_live" label="开启直播">
                    <template #input>
                        <van-switch v-model="single.option_live" size="20" active-value="1" inactive-value="0"/>
                    </template>
                </van-field>
                <van-field
                    v-model="single.password"
                    name="topic"
                    label="密码"
                    placeholder="6位纯数字"
                    type="digit"
                    :rules="[{pattern}]"
                    center
                    clearable
                >
                    <template #button>
                        <el-button size="small" plain  type="primary" @click="makeRandomPassword">生成</el-button>
                    </template>
                </van-field>
                <van-field
                    v-model="single.assistants"
                    name="topic"
                    label="联席主持"
                    placeholder="联席主持人的jAccount账号"
                    center
                    clearable
                >
                </van-field>
                <van-field
                    v-model="single.description"
                    name="description"
                    placeholder="填写会议内容"
                    rows="2"
                    label="会议内容"
                    type="textarea"
                    maxlength="100"
                    show-word-limit
                />
            </van-cell-group>
            <div class="m-3 d-flex mb-4">
                <van-button block type="info" native-type="submit" class="mr-4">提交申请</van-button>
                <van-button block type="default" @click="$router.replace('/jwb/meetings')">返回列表</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import {Button, Field, CellGroup, Cell, Form, Popup, DatetimePicker, Calendar, Picker, Switch, Toast,Dialog} from "vant";
import 'vant/lib/index.less';
import MeetingFreebusy from "@/components/Meeting-FreeBusy-jwb";
import editMixin from "@/common/mixins/front-edit-mixin";

export default {
    name: "edit.vue",
    mixins: [editMixin],
    data() {
        return {
            pattern: /\d{6}/,
            showDateTimePicker: false,
            showCalendar: false,
            showDurationPicker: false,
            show_picker: {
                group_id: false,
            },
        }
    },
    components: {
        [Button.name]: Button,
        [Field.name]: Field,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Form.name]: Form,
        [Popup.name]: Popup,
        [DatetimePicker.name]: DatetimePicker,
        [Calendar.name]: Calendar,
        [Picker.name]: Picker,
        [Switch.name]: Switch,
        MeetingFreebusy,
    },
    methods: {
        onSubmit() {
            let vm = this;
            vm.is_loading = true;
            vm.single.attendees = JSON.stringify(vm.emails);
            Toast.loading({message: '检查中...', forbidClick: true});
            vm.$api('Meeting.Edit', Object.assign({}, vm.single, {ask: 1}), false).then((res) => {
                if (!res.data.success) {
                    Toast.clear();
                    Toast.fail(res.data.text);
                } else {
                    if (res.data.data === 'CONFIRM') { // 确认后再次调用
                        Toast.clear();
                        vm.is_loading = false;
                        vm.$affirm('此次操作将会变更会议号码，请确定是否继续?').then(() => {
                            Toast.loading({message: '检查中...', forbidClick: true});
                            vm.is_loading = true;
                            vm.$api('Meeting.Edit', vm.single, true).then(() => {
                                Toast.clear();
                                vm.is_loading = false;
                                const ret = res.data.data;
                                this.afterSubmit(ret);
                            }).catch(() => {
                                vm.is_loading = false;
                                vm.$refs['meeting_busy'].queryBF();
                            });
                        });
                    } else {
                        Toast.clear();
                        vm.is_loading = false;
                        const ret = res.data.data;
                        this.afterSubmit(ret);
                    }
                }
            }).catch(() => {
                vm.is_loading = false;
                vm.$refs['meeting_busy'].queryBF();
            });

        },
        afterSubmit(ret) {
            const vm=this;
            if(ret.message === "CREATED" || ret.message === "UPDATED") {
                Dialog.confirm({
                    confirmButtonText:"邀请参会者",
                    cancelButtonText:'关闭',
                    message: "您的会议已经"+(ret.message=== "CREATED"?"创建":"更新")+"，是否使用会议通知服务邀请参会者？"
                }).then(()=>{
                    window.open(ret.data,"_blank");
                    vm.$router.push(this.$organization.home_page);
                }).catch(() => {
                    vm.$router.push(this.$organization.home_page);
                });
            } else {
                Dialog.alert({
                    confirmButtonText:'关闭',
                    message: "您申请的会议需要管理员审批，审批完成后您将受到邮件通知。",
                }).then(() => {
                    vm.$router.push(this.$organization.home_page);
                });
            }
        },
        onConfirmDate(date) {
            this.single.meeting_date = date.Format('yyyy-MM-dd');
            this.showCalendar = false;
        },
        onConfirmTime(time) {
            this.single.meeting_time = time;
            this.showDateTimePicker = false;
        },
        onDurationConfirm(value) {
            this.single.duration = value.value;
            this.showDurationPicker = false;

        },
        timeFilter(type, options) {
            if (type === 'minute') {
                return options.filter((option) => option % 30 === 0);
            }
            return options;
        },
        findLabel(value, array, key) {
            const one = array.find(item => key ? item[key] === value : item.value === value);
            if (one) return key ? one.name : one.label;
            return '';
        },
        onPickConfirm(item, value) {
            let final = value.value;
            if (value.hasOwnProperty('id')) {
                final = value.id;
            }
            this.$set(this.single, item, final);
            this.$set(this.show_picker, item, false);
        },
        changeCheck(v) {
            if (v === 0) {
                if (this.single.waiting_room) {
                    this.single.option_jbh = 0;
                }
            } else {
                if (this.single.option_jbh) {
                    this.single.waiting_room = 0;
                }
            }
        }
    }

}
</script>

<style scoped>

</style>
